import {
  BookOpenIcon,
  BuildingLibraryIcon,
  PhoneIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUserEventStatus } from "../../../../api/users/users";
import dayjs from "dayjs";

const EventCard = ({ event }) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: updateUserEventStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userEvents"] });
    },
  });

  const cancelEvent = async () => {
    const confirmed = window.confirm(
      `Είσαι σίγουρος ότι θέλεις να ${event?.status === "accepted" ? "ακυρώσεις" : "μην αποδεχτείς"} την ομιλία;`,
    );
    if (confirmed) {
      mutate({
        eventId: event.id,
        newStatus: "rejected",
      });
    }
  };

  return (
    <tr
      className={`text-xs py-1 border-b last:border-0 border-gray-300 cursor-default ${
        event.status === "pending" ? "bg-amber-50/70" : ""
      }`}
    >
      <td className="pl-5 pr-3 whitespace-no-wrap">
        <div className={"mb-1 text-gray-900"}>Ημερομηνία:</div>
        <div className={"font-semibold"}>
          {dayjs(event.datetime).format("DD-MM-YYYY")}
        </div>
        <div className={"font-semibold"}>
          {dayjs(event.datetime).format("HH:mm")}
        </div>
      </td>

      <td className="px-2 py-2 whitespace-no-wrap">
        <div className="leading-5 text-gray-800 font-medium">
          <div className={"flex flex-row items-center gap-1"}>
            <BuildingLibraryIcon className={"size-3.5"} />
            <span>{event?.meetingHouse}</span>
          </div>
        </div>
        <div className="leading-5 text-gray-800">
          <div className={"flex flex-row items-center gap-1"}>
            <BookOpenIcon className={"size-3.5"} />
            <span className={"font-semibold"}>{event?.number}</span>
          </div>
        </div>
        <div className="leading-5 text-gray-900">
          <div className={"flex flex-row items-center gap-1"}>
            <PhoneIcon className={"size-3.5"} />
            <a
              className="text-blue-500 hover:underline"
              href={`tel:${event.contactPhone}`}
            >
              {event.contactPhone}
            </a>
          </div>
        </div>
      </td>
      <td className="pl-5 pr-3 pt-3 whitespace-no-wrap grid gap-2 h-full items-center">
        {event?.status === "pending" && (
          <button
            onClick={() => {
              mutate({
                eventId: event.id,
                newStatus: "accepted",
              });
            }}
            className={"bg-amber-400 p-1 rounded-2xl"}
          >
            Δέχομαι
          </button>
        )}
        <button
          onClick={cancelEvent}
          className={
            "bg-red-100 text-red-800 p-1 rounded-2xl inline-flex justify-center items-center"
          }
        >
          <XMarkIcon className={"size-4"} />
          {event?.status === "pending" ? "Δεν δέχομαι" : "Ακύρωση"}
        </button>
      </td>
    </tr>
  );
};

export default EventCard;
